import axios from 'utils/axios';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  fetchUserGroups: {
    isLoading: false,
    error: false,
    data: [],
  },
  createUserGroup: {
    isLoading: false,
    error: false,
    success: false,
  },
};

const slice = createSlice({
  name: 'targetUserGroup',
  initialState,
  reducers: {
    // Fetch User Groups
    fetchUserGroupsStart(state) {
      state.fetchUserGroups.isLoading = true;
      state.fetchUserGroups.error = false;
    },
    fetchUserGroupsSuccess(state, action) {
      state.fetchUserGroups.isLoading = false;
      state.fetchUserGroups.data = action.payload;
    },
    fetchUserGroupsError(state, action) {
      state.fetchUserGroups.isLoading = false;
      state.fetchUserGroups.error = action.payload;
    },

    // Create User Group
    createUserGroupStart(state) {
      state.createUserGroup.isLoading = true;
      state.createUserGroup.error = false;
      state.createUserGroup.success = false;
    },
    createUserGroupSuccess(state) {
      state.createUserGroup.isLoading = false;
      state.createUserGroup.success = true;
    },
    createUserGroupError(state, action) {
      state.createUserGroup.isLoading = false;
      state.createUserGroup.error = action.payload;
    },
  },
});

export default slice.reducer;

export const {
  fetchUserGroupsStart,
  fetchUserGroupsSuccess,
  fetchUserGroupsError,
  createUserGroupStart,
  createUserGroupSuccess,
  createUserGroupError,
} = slice.actions;

export function getTargetUserGroups(appId) {
  return async (dispatch) => {
    dispatch(fetchUserGroupsStart());
    try {
      const response = await axios.get(`/monetization/${appId}/target-user-groups`);
      dispatch(fetchUserGroupsSuccess(response));
    } catch (error) {
      dispatch(fetchUserGroupsError(error.response?.data?.message || error.message));
    }
  };
}

export function createTargetUserGroup(appId, data) {
  return async (dispatch) => {
    dispatch(createUserGroupStart());

    try {
      const response = await axios.post(`/monetization/${appId}/target-user-groups`, data);
      dispatch(createUserGroupSuccess(response));
      return response;
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      dispatch(createUserGroupError(message));
      throw new Error(message);
    }
  };
}
